var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodmeshLogoRectangleNotagline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 70",
    style: {
      enableBackground: "new 0 0 320 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#19493A;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.8916,
    y1: 87.8682,
    x2: 89.5661,
    y2: 0.09738248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    style: {
      stopColor: "#91C248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3314,
    style: {
      stopColor: "#5FA844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    style: {
      stopColor: "#379341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7201,
    style: {
      stopColor: "#1A843F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#097B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03783D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,59h5.2V27.2H1v-7h33.8v13.1h-7.5v-6.1H14.1v13.1h13.5V47H14.1v12h6.1v7H1V59z M31.2,52.3 c0-7.5,5.6-14.2,14.6-14.2c9.1,0,14.6,6.6,14.6,14.2c0,7.5-5.6,14.2-14.6,14.2C36.7,66.5,31.2,59.9,31.2,52.3z M53.4,52.3 c0-5-3.1-8.5-7.6-8.5s-7.6,3.5-7.6,8.5s3.1,8.5,7.6,8.5S53.4,57.3,53.4,52.3z M64,52.3c0-7.5,5.6-14.2,14.6-14.2 c9.1,0,14.6,6.6,14.6,14.2c0,7.5-5.6,14.2-14.6,14.2C69.5,66.5,64,59.9,64,52.3z M86.2,52.3c0-5-3.1-8.5-7.6-8.5 c-4.4,0-7.6,3.5-7.6,8.5s3.1,8.5,7.6,8.5C83,60.8,86.2,57.3,86.2,52.3z M96.8,52.4c0-7.9,5.8-14.3,13.1-14.3 c3.5,0,6.1,1.3,7.6,2.6V26h-4.1v-5.8h10.9v40.2h4.1V66h-10.9v-3c-2,1.9-4.6,3.5-8.1,3.5C102.2,66.5,96.8,60.7,96.8,52.4z  M117.6,57.9V46.1c-1.8-1.3-3.9-2.1-6.5-2.1c-3.8,0-7.3,2.9-7.3,8.4c0,5.3,3.3,8.3,7.3,8.3C113.6,60.6,115.7,59.5,117.6,57.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#19493A",
    d: "M134.9,24.2c0-2.2,1.8-4,4-4h0.8c1.8,0,2.9,0.9,3.7,2.1l13.8,21.6l13.9-21.7c0.8-1.4,2-2.1,3.6-2.1h0.8 c2.3,0,4,1.8,4,4v38.1c0,2.2-1.8,4-4,4c-2.1,0-4-1.8-4-4V35l-11.1,16.7c-0.8,1.3-1.9,2.1-3.4,2.1c-1.4,0-2.5-0.8-3.3-2.1 l-11.1-16.6v27.3c0,2.2-1.8,3.9-4,3.9s-3.9-1.7-3.9-3.9V24.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#19493A",
    d: "M198,66.6c-8.1,0-14.3-5.9-14.3-14.5v-0.1c0-8,5.6-14.5,13.6-14.5c8.9,0,13.2,7.3,13.2,13.7 c0,1.8-1.4,3.1-3,3.1h-17.5c0.7,4.5,3.9,7.1,8,7.1c2.7,0,4.8-0.9,6.6-2.4c0.5-0.4,0.9-0.6,1.6-0.6c1.4,0,2.5,1.1,2.5,2.6 c0,0.8-0.4,1.5-0.8,2C205.5,65.2,202.3,66.6,198,66.6z M204.3,50.1c-0.4-4.1-2.8-7.3-7.1-7.3c-3.9,0-6.6,3-7.2,7.3H204.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#19493A",
    d: "M214.4,63.2c-0.7-0.4-1.2-1.2-1.2-2.2c0-1.4,1.1-2.6,2.6-2.6c0.5,0,1,0.2,1.4,0.4c2.7,1.8,5.5,2.7,8,2.7 c2.7,0,4.3-1.2,4.3-3v-0.1c0-2.2-3-2.9-6.2-3.9c-4.1-1.2-8.7-2.8-8.7-8.2v-0.1c0-5.3,4.4-8.5,9.9-8.5c3,0,6.1,0.8,8.8,2.3 c0.9,0.5,1.5,1.3,1.5,2.4c0,1.5-1.2,2.6-2.6,2.6c-0.5,0-0.8-0.1-1.3-0.3c-2.3-1.2-4.6-1.9-6.5-1.9c-2.5,0-3.9,1.2-3.9,2.7v0.1 c0,2.1,3,2.9,6.3,4c4.1,1.3,8.7,3.1,8.7,8.1v0.1c0,5.9-4.5,8.8-10.3,8.8C221.5,66.5,217.6,65.4,214.4,63.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#19493A",
    d: "M239.3,30.4c0-1.7,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2v12c1.8-2.6,4.4-4.9,8.7-4.9c6.3,0,9.9,4.2,9.9,10.7v14.9 c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2V50.2c0-4.3-2.2-6.8-6-6.8c-3.7,0-6.3,2.6-6.3,6.9v12.8c0,1.8-1.4,3.2-3.2,3.2 c-1.7,0-3.2-1.4-3.2-3.2V30.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5293,
    y1: 31.2756,
    x2: 287.0009,
    y2: 31.2756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03783D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#2A8C40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3482,
    style: {
      stopColor: "#59A544"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#7EB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#99C748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    style: {
      stopColor: "#A9CF4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD24A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.5,37.6C305.5,37.6,305.5,37.6,305.5,37.6c0.7-1,1.9-0.9,2.9-0.4c0,0,0.1,0.1,0.1,0.1 c0.4,0.2,0.9,0.4,1.3,0.6l0-0.1c0.1-0.7,0.1-1.5,0.2-2.3c0.1-0.6,0.3-1.4,1-1.8c0.5-0.3,1-0.3,1.5-0.1c0.1,0,0.1,0,0.2,0.1 c0,0,0.1,0.1,0.1,0.1c0.6,0.5,0.7,1.3,0.6,2c0,0.7,0,1.5,0,2.2c0,0.7,0,1.4,0,2.2c0,1.2-0.5,1.8-0.9,2c-0.3,0.2-0.9,0.5-1.6,0.2 c-1.5-0.6-2.9-1.3-4.3-2l-0.1-0.1c-0.3-0.1-0.5-0.3-0.8-0.4C304.9,39.4,305,38.3,305.5,37.6z M299.8,26.1c-0.5-0.4-1-0.6-1.7-0.8 c-1.6-0.5-3.5-0.2-4.5,1.2c-0.8,1-1.6,2.6-2.4,3.8c-0.6,1-2.4,3.2-3.7,1.9c-1.2-1.2-0.2-3,0.4-4.3c1.2-2.7,3.4-6,6.2-7.2 c1.9-0.8,4.2-0.8,6.1,0.1c2.3,1.1,4.1,3,5.5,5c1.4,2.1,3.3,4.6,3.3,7.2c0,0.5-0.1,1.1-0.5,1.4c-0.3,0.2-0.7,0.3-1,0.3 c-1.3,0-2.2-1-2.8-2.1C303.4,30.6,302.1,27.7,299.8,26.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.3302,
    y1: 493.893,
    x2: 190.3302,
    y2: 526.4544,
    gradientTransform: "matrix(0.9952 -9.750323e-02 9.750323e-02 0.9952 44.1477 -438.9217)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03783D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#2A8C40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3482,
    style: {
      stopColor: "#59A544"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#7EB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#99C748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    style: {
      stopColor: "#A9CF4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD24A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M288.4,35.5c0,0.7,0.1,1.4,0.1,2.2c0,0.7,0.1,1.3,0.1,2c0.1,1-0.4,2.5-1.6,2.7c-1.6,0.3-2-1.4-2.2-2.6 c0-0.2-0.1-0.6-0.1-0.8c-0.2,0-0.8,0.3-1.5,0.7c-0.2,0.1-0.4,0.3-0.6,0.3c-0.3,0.2-1.4,0.6-2.2-0.3c-0.3-0.4-0.4-0.8-0.4-1.2 c0.1-0.5,0.4-1,0.8-1.3c1.6-1.1,3.2-2.3,4.9-3.3c0.8-0.5,1.4-0.4,1.8-0.2C287.9,33.9,288.3,34.4,288.4,35.5z M283.3,46.8 c0,0.1-0.1,0.2-0.1,0.4c-0.4,1.5-0.9,2.9-0.9,4.4c0,1.6,0.4,3.4,1.2,4.9c1.4,2.7,3.9,4.9,6.8,5.7c0.9,0.3,1.9,0.5,2.2,1.4 c0.2,0.6-0.1,1.4-0.7,1.8c-0.5,0.4-1.2,0.6-1.9,0.6c-2.4,0.3-5-0.4-7.1-1.7c-2.1-1.3-3.8-3.1-5.1-5.2c-1.1-1.8-1.9-3.8-1.9-5.9 c0-2,0.7-3.9,1.7-5.6c1.1-1.9,2.5-3.9,4.2-5.3c1.4-1.1,2.9,0.1,2.7,1.6C284.3,44.7,283.6,46,283.3,46.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -9600.2764,
    y1: 79.1069,
    x2: -9589.2988,
    y2: 94.9681,
    gradientTransform: "matrix(-0.9027 -0.4511 0.6247 -1.0428 -8409.1006 -4182.1562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03783D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#2A8C40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3482,
    style: {
      stopColor: "#59A544"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#7EB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#99C748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8778,
    style: {
      stopColor: "#A9CF4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFD24A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.7,60.6c-0.2,1.2-1.1,1.7-2.3,1.8c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0.1-1.5,0.1l0,0.1 c0.3,0.7,0.6,1.4,0.9,2.1c0.2,0.6,0.4,1.4,0,2.1c-0.3,0.5-0.7,0.7-1.3,0.8c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.2,0 c-0.8-0.2-1.2-0.8-1.5-1.4c-0.3-0.7-0.7-1.3-1-1.9c-0.3-0.6-0.7-1.2-1-1.9c-0.5-1-0.4-1.8-0.2-2.2c0.2-0.4,0.5-0.8,1.3-1 c1.6-0.2,3.2-0.3,4.7-0.4l0.1,0c0.3,0,0.6,0,0.9,0C301.3,58.7,301.8,59.6,301.7,60.6C301.7,60.5,301.7,60.6,301.7,60.6z  M319,52.5c-0.1-1.9-0.8-3.8-1.4-5.6c-0.5-1.3-1.2-2.8-2.4-3.6c-0.5-0.4-1.1-0.5-1.7-0.1c-0.7,0.4-0.8,1.2-0.7,1.9 c0.4,2.3,1.2,5,0.6,7.3c-0.7,3-2.6,5.9-5,7.9c-1.8,1.4-3.6,2.2-5.9,2.3c-0.7,0-2.2,0.1-2.3,1.1c0,0.5,0.3,0.9,0.7,1.2 c1.7,1.4,4.4,1.2,6.4,0.9c3.5-0.6,6-1.9,8.2-4.4c1.6-1.8,2.9-4,3.3-6.5C319,54.1,319,53.3,319,52.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.9646,
    y1: 10.3845,
    x2: 317.6577,
    y2: 10.3845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    style: {
      stopColor: "#91C248"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3314,
    style: {
      stopColor: "#5FA844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    style: {
      stopColor: "#379341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7201,
    style: {
      stopColor: "#1A843F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#097B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03783D"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.1,16.4c-0.1,0.9-0.5,1.6-1.2,1.8c-0.2,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.8-0.1-1.2-0.6 c-0.7-0.8-0.7-1.7-0.8-2.4c0-0.1,0-0.3,0-0.4c-0.1-1.3-0.4-2.2-1.1-2.9c0,0,0,0,0,0c-0.4,0.2-1.1,0.4-1.9,0.1l-0.1,0 c-1.1-0.6-1.7-1.7-1.4-2.7c0.4-1.4,1.8-1.6,2.4-1.7c1.7-0.2,3.2,0.5,4.2,2.2C297.8,11.7,298.3,13.8,298.1,16.4z M299.4,17.5 c0.1,0.2,0.2,0.3,0.3,0.4c0.4,0.3,0.5,0,0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.9c0.5-0.6,1.1-1.1,1.7-1.6l0.2-0.2 c1.7-1.4,3.6-2.6,5.9-3.6l0.1,0c0.2-0.1,0.9-0.4,0.7-1.1c-0.2-0.6-1-0.4-1.2-0.3l-0.3,0.1c-1.5,0.5-3.1,1-4.5,2 c-1.7,1.1-3.1,2.6-4.3,4.5c0,0,0,0,0,0.1C299.4,16.8,299.2,17.1,299.4,17.5z M299.9,13.8c-0.1,0-0.2-0.1-0.3-0.2 c-0.4-0.6-0.4-1.3-0.1-1.9c0.3-0.7,0.9-1.4,1.5-1.9c2.3-2,5.5-3,8.2-4.2c1.2-0.5,2.5-1.1,3.6-1.7c0.7-0.4,1.1-1.5,2-1.4 c1.8,0.2,2.8,4,2.8,5.4c0,0.3,0,0.5,0,0.8c-0.1,1.9-0.5,3.8-2,5.1c-1.7,1.4-3.8,2.2-5.8,2.8c-1.7,0.5-3.3,1-5,1.6 c-0.7,0.3-1.3,0.2-1.8-0.4c-0.3-0.3-0.8-0.9-0.3-1.3c0.3-0.3,1-0.5,1.4-0.7c0.5-0.3,1.1-0.5,1.7-0.8c1.5-0.7,3.1-1.1,4.5-1.9 c1.3-0.7,2.6-1.6,3.5-2.7c1.1-1.2,1-2.7,0.8-4.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.8,0.6-1.9,0.9-2.8,1.3c-1,0.4-2,0.8-3.1,1.2 c-1.7,0.6-3.3,1.1-4.9,2c-0.6,0.3-1.2,0.7-1.7,1.2c-0.5,0.5-0.9,1-1.4,1.5C300.4,13.7,300.2,13.8,299.9,13.8 C300,13.8,299.9,13.8,299.9,13.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodmeshLogoRectangleNotagline);
export default __webpack_public_path__ + "static/media/foodmesh_logo_rectangle_notagline.6ccae5f9.svg";
export { ForwardRef as ReactComponent };